import React, { Component } from "react";

class IntroV3 extends Component {
  render() {
    return (
      <div className="intro-area " style={{ paddingTop: "50px" }}>
        <div className="container">
          <div className="section-title text-lg-center text-left">
            <h2 className="title">
              <span>Upoznajte</span> Prokurator
            </h2>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="single-intro style-two">
                <h4 className="intro-title">Misija</h4>
                <p>
                  Pomoći klijentima da rastu kroz digitalni marketing i vanjsko
                  oglašavanje — ravnopravno, brzo i mjerljivo. Od SEO-a i Google
                  Ads kampanja do ploha na najprometnijim lokacijama, sve iz
                  jednog tima.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="single-intro style-two">
                <h4 className="intro-title">Vizija</h4>
                <p>
                  Biti vodeći marketing partner u Dalmaciji i Hrvatskoj:
                  digitalni marketing i vanjsko oglašavanje pod istim krovom,
                  uz stalno širenje kanala i lokacija na tržištu i izvan
                  granica.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default IntroV3;
